export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8873.407c1949.jpg";